var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.feedbackEnabled
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  _vm.lang === "en"
                    ? "https://loan.csuzdi.hu"
                    : "https://hitel.csuzdi.hu",
                target: "_blank"
              }
            },
            [_vm._v(_vm._s(_vm.T.loanCalculator[_vm.lang]))]
          ),
          _vm._v("\n    |\n    "),
          _c(
            "a",
            { attrs: { href: "https://ido.csuzdi.hu", target: "_blank" } },
            [_vm._v(_vm._s(_vm.T.workdayCalculator[_vm.lang]))]
          ),
          _vm._v("\n    |\n    "),
          _c(
            "a",
            {
              attrs: {
                href: "https://dreamjobs.hu/hu/fizetesek",
                target: "_blank"
              }
            },
            [_vm._v(_vm._s(_vm.T.salaryRanges[_vm.lang]))]
          ),
          _vm._v("\n    |\n    "),
          _c("a", { attrs: { href: _vm.maillink } }, [
            _vm._v(_vm._s(_vm.T.feedback[_vm.lang]))
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ddcac90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ddcac90","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/Feedback.vue
// module id = 31
// module chunks = 0